import { YinzCamSoccerAppServer } from './YinzCamSoccerAppServer';
import { YinzCamAPI } from 'yinzcam-api';
import { register } from 'yinzcam-registry';
import { APP_SERVER_REGISTRY } from './constants';
import { YinzCamAppServer } from './YinzCamAppServer';

@register(APP_SERVER_REGISTRY, 'nfl')
export class YinzCamNFLAppServer extends YinzCamAppServer {
  public constructor(api: YinzCamAPI) {
    console.log ('yinzcam nfl server: ', api)
    super(api, 'V1/'); //This is test. In future, the prefix should be removed.
  }

  public saveNewGroup(icon: string|number, name: string, participants: string[]) {
    return this.saveNewGroupRequest({ImageUrl: icon, Name: name, participants});
  }

  public saveNewChat(data: any) {
    return this.saveNewChatRequest(data);
  }
}
